import { render } from "./my_drops_list_item.vue?vue&type=template&id=cc220866&ts=true"
import script from "./my_drops_list_item.vue?vue&type=script&lang=ts"
export * from "./my_drops_list_item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__